import type { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { list } from '../../../../../common/classes/request-builder';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { ClienteModel } from 'src/app/models/cliente.model';

export class VentasListsDefinition {
    public fincas: DropdownData<FincasModel> = list();
    public sectores: DropdownData<SectorModel[]> = list();
    public parcelas: DropdownData<ParcelasModel | ParcelasModel[]> = list();
    public variedades: DropdownData<VisitasVariedadMesModel> = list();
    public compradores: DropdownData<Compradores> = list();
    public clientes: DropdownData<ClienteModel> = list();
    public clientes_comercios: DropdownData<Compradores> = list();
    public cooperativas: DropdownData<string> = list();
}